module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-map-selezione-fogli gv-inverted-color-scheme",
    attrs: {
      "id": "gv-map-selezione-fogli"
    }
  }, [_vm._c('gv-title', {
    directives: [{
      name: "draggable",
      rawName: "v-draggable"
    }],
    attrs: {
      "title": _vm.title,
      "divId": 'gv-map-selezione-fogli',
      "noClose": true,
      "collapsible": 'gv-map-selezione-fogli-body'
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-map-selezione-fogli-body",
    attrs: {
      "id": "gv-map-selezione-fogli-body"
    }
  }, [_vm._c('el-select', {
    attrs: {
      "size": "mini",
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "Seleziona"
    },
    model: {
      value: (_vm.fogli),
      callback: function($$v) {
        _vm.fogli = $$v
      },
      expression: "fogli"
    }
  }, _vm._l((_vm.config.fogli), function(item) {
    return _vm._c('el-option', {
      key: item.codice,
      attrs: {
        "value": item.codice,
        "label": item.nome
      }
    })
  })), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-map-selezione-fogli-buttons"
  }, [_vm._c('el-button', {
    attrs: {
      "id": "gv-map-selezione-fogli-submit",
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Conferma")]), _vm._v(" "), _vm._c('el-button', {
    attrs: {
      "id": "gv-map-selezione-fogli-cancel",
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Annulla")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71b34ef7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelezioneFogli.vue
// module id = 885
// module chunks = 39